<template>
  <div :class="[border ? 'user-all-titles' : 'user-all-titie']">
    <h5 v-if="!tab">{{ title }}</h5>
    <div v-if="tab" class="user-title-tab">
      <a
        :class="[active == index ? 'active' : '']"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabClick(item, index)"
        >{{ item }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    border: {
      type: Boolean,
      default: false
    },
    tab: {
      type: Boolean,
      default: false
    },
    tabList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tabClick: {
      type: Function
    },
    active: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style scoped>
.user-all-titie {
  padding: 24px;
  background: #fbfcff;
}
.user-all-titie h5 {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  text-align: left;
}
.user-all-titles {
  padding-bottom: 34px;
  border-bottom: 1px solid #f7f8ff;
}
.user-all-titles h5 {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  text-align: left;
}
.user-all-titles a {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  text-align: left;
  margin-right: 50px;
  cursor: pointer;
}
.user-all-titles .active {
  color: #3382ff !important;
  position: relative;
}
.user-all-titles .active::after {
  transform: rotateY(0deg);
}
.user-all-titles a::after {
  content: "";
  border-bottom: 2px solid #3382ff;
  transform: rotateY(90deg);
  transition: transform 0.5s ease;
  width: 100%;
  position: absolute;
  bottom: -35px;
  display: block;
}
.user-title-tab {
  display: flex;
  justify-content: flex-start;
}
</style>
